module.exports = __webpack_public_path__ + "static/media/TasklySurvey.80c0619e.png";